import React from 'react';

import Clock from '../icons/Clock';
import * as styles from './styles/styles.module.scss';

const PendingEditLabel = () => (
  <div className={styles.wrapper}>
    <Clock />
    <span>Pending edit</span>
  </div>
);

export default PendingEditLabel;
